import { LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	config: {
		// The article paints its own white publisher surface, so the landing must not put its base
		// gray behind it — otherwise `.landing__layout`'s 120px cookie-banner pad shows as a gray
		// strip under the last CTA.
		background: 'transparent',
		analytics: {
			screenId: 'article',
		},
	},
	order: ['LandingArticle'],
	components: {},
}

export default schema
